import TeachrContact from "../Objects/models/TeachrContact";
import { Route } from "../Objects/enums/RouteEnum";
import ApiService from "../Services/ApiService";
// import Teachr from "../Objects/models/Teachr";
// import HydraCollection from "../Objects/models/HydraCollection";
// import { plainToClass } from "class-transformer";
export default class TeachrContactRepository {
    /**
     * Creates an instance of Teachr into the API.
     * @param teachrContact
     */
    public static createTeachrContact(teachrContact: TeachrContact) {
        return ApiService.postInstance<TeachrContact>(
            Route.TEACHRCONTACT_BASE,
            TeachrContact,
            teachrContact
        );
    }
    public static fetchTeachrContactByKey(key: string) {
        return ApiService.get(`/teachrContact/client/${key}`)
    }
    public static fetchTeachrContactByMail(mail: string) {
        return ApiService.get(`/teachrContact/client/mail/${mail}`)
    }
    public static fetchTeachrContactByMail2(teachr:number,mail: string) {
        return ApiService.get(`/teachrs/${teachr}/client/${mail}`)
    }
    public static fetchClientByTeachr(teachrId: number) {
        return ApiService.get(`/teachrs/get/client/${teachrId}`)
    }
    public static fetchClientByTeachr2(teachrId: number) {
        return ApiService.get(`/teachrs/get/client/${teachrId}/archives`);
    }
    
    public static updateTeachrContact(teachrContact: TeachrContact) {
        return ApiService.putInstance<TeachrContact>(
            Route.TEACHRCONTACT_BASE +'/' + teachrContact.id,
            TeachrContact,
            teachrContact
        );
    }
    public static deleteTeachrContact(teachrContact: number) {
        return ApiService.putInstance(`/teachr-contact/${teachrContact}`);
    }

    public static async putPhoneNumber(teachrContact:number, phone:string) {
        return ApiService.put(
            `/teachrs/${teachrContact}/put_phone/${phone}`
        );
    }
}